import { render, staticRenderFns } from "./SurveyRadioButton.vue?vue&type=template&id=dc32b990&"
import script from "./SurveyRadioButton.vue?vue&type=script&lang=js&"
export * from "./SurveyRadioButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports